<template>
  <div class="consultingmain">
    <div class="main">
      <div class="bgc"></div>
      <div class="zixun">
        <p class="text-title">消费者权益保护和征信异议受理</p>
        <div class="zixun-container">
          <div class="text">
            <p>消费者权益保护热线：400-100-3066</p>
            <p>区县监管部门咨询、投诉电话：023-68788560</p>
          </div>
          <div class="qr-code">
            <img :src="require(`@/assets/${mapDomainUrl[currentUrl]?mapDomainUrl[currentUrl]:'loan-credit-issues-h5-dev.png'}`)" alt="">
            <div class="qr-code-name">隆携小贷征信异议申请</div>
          </div>
          <div class="qr-code" style="margin-left: 5%;">
            <img :src="require(`@/assets/${mapDomainUrl[currentUrl]?mapDomainUrl[currentUrl]:'loan-credit-issues-h5-dev.png'}`)" alt="">
            <div class="qr-code-name">隆携小贷反洗钱异议申请</div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'consulting',
  data() {
    return {
      currentUrl: window.location.href.split('/#')[0],
      mapDomainUrl: {
        'http://localhost:8080': 'loan-credit-issues-h5-dev.png',
        'https://loan-longxie-dev.tenserpay.xyz': 'loan-credit-issues-h5-dev.png',
        'https://loan-longxie-prj.tenserpay.xyz': 'loan-credit-issues-h5-prj.png',
        'https://www.longxie.net': 'loan-credit-issues-h5.longxie.net.png',
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.consultingmain {
  width: 100%;

  .main {
    width: 100%;

    .bgc {
      width: 100%;
      height: 450px;
      background: url("../../assets/咨询投诉.jpg") center top no-repeat;
      background-size: 100% 135%;
    }

    .zixun {
      padding: 0 20px;

      .text-title {
        font-size: 30px;
        text-align: left;
        margin: 20px 0 10px 0;
      }

      .zixun-container {
        display: flex;
        align-items: center;
        background-color: #f2f2f2;

        .text {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          height: 120px;
          text-align: left;
          padding: 20px 0 20px 30px;

          p {
            margin: 0;
            font-size: 18px;
          }
        }

        .qr-code {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-left: 20%;
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Consulting/index.vue